<div
  class="instruction-card"
  [class.new-change]="hasChanged && changeType === VbRecurringPaymentChangeTypeEnum.New"
  [class.current-change]="hasChanged && changeType === VbRecurringPaymentChangeTypeEnum.Current">
  <!-- Active Payment Only -->
  <app-vb-payment-change-submission-active-payment
    class="w-100"
    *ngIf="activeRecurringPaymentInstruction && !scheduledRecurringPaymentInstruction"
    [frequency]="frequency"
    [activeRecurringPaymentInstruction]="activeRecurringPaymentInstruction" />

  <!-- Scheduled Payment Only -->
  <app-vb-payment-change-submission-scheduled-payment
    class="w-100"
    *ngIf="!activeRecurringPaymentInstruction && scheduledRecurringPaymentInstruction"
    [frequency]="frequency"
    [scheduledRecurringPaymentInstruction]="scheduledRecurringPaymentInstruction" />

  <!-- Active & Scheduled Payment -->
  <app-vb-payment-change-submission-multiple-payments
    class="w-100"
    *ngIf="scheduledRecurringPaymentInstruction && activeRecurringPaymentInstruction"
    [frequency]="frequency"
    [scheduledRecurringPaymentInstruction]="scheduledRecurringPaymentInstruction"
    [activeRecurringPaymentInstruction]="activeRecurringPaymentInstruction" />

  <!-- Empty State -->
  <div *ngIf="!activeRecurringPaymentInstruction && !scheduledRecurringPaymentInstruction" class="w-100">
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex flex-column gap-2">
        <span class="instruction-card-value">{{ frequency | vbPaymentChangeRecurringPaymentFrequencyLabel }}</span>
        <div class="instruction-card-payment-label" i18n>No Payment Details Entered</div>
      </div>
      <div class="d-flex align-items-center">
        <div class="instruction-card-payment-label" [style.margin-left]="'auto'" i18n>
          {{ 0 | recurringPaymentFrequency : frequency }}
        </div>
      </div>
    </div>
  </div>
</div>
